module.exports = __webpack_public_path__ + "static/media/logo.167ac10a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/header/logo.webp
// module id = 893
// module chunks = 9